module.exports = __webpack_public_path__ + "img/susie-king-taylor.1cf62c38.png";